import styled from 'styled-components';
import LoginForm from './LoginForm';

export default styled(LoginForm)`
  width: 100%;

  .login-form {
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 100%;

    &__input {
      height: 48px;
      margin-bottom: 1rem;
      max-width: 320px;
      width: 100%;

      &:last-of-type {
        margin-bottom: 0;
      }

      input {
        font-size: 1.6rem;
        line-height: 1.31;
        height: 48px;
      }

      &--error {
        margin-bottom: 0;
      }
    }

    &__label {
      display: flex;
      margin-bottom: 1rem;
      visibility: hidden;
    }

    &__inputs-container {
      align-items: center;
      display: flex;
      flex-direction: column;
      margin-bottom: 3.2rem;
      max-width: 320px;
      width: 100%;
    }

    &__submit {
      border-radius: 4px;
      height: 48px;
      max-width: 320px;
      width: 100%;
    }
  }
`;
